import request from 'superagent';
import { logToAppInsights } from '../utils/AppInsights';
import { msalConfig, authRequest } from '../constants/authConfig';
import { msalInstance } from '../../index';

import { InteractionRequiredAuthError } from '@azure/msal-browser';

export function getAccessTokenAsync(token) {
  if (token) {
    return new Promise((resolve, reject) => {
      if (msalInstance) {
        const account = msalInstance.getActiveAccount();
        if (!account) {
          reject(
            Error(
              'No active account! Verify a user has been signed in and setActiveAccount has been called.'
            )
          );
        }

        var tokenRequest = Object.assign({}, authRequest, { account: account });

        resolve(msalInstance.acquireTokenSilent(tokenRequest));
      } else {
        resolve(null);
      }
    });
  }

  return Promise.resolve(null);
}

const Helpers = {};

let logRequest = (request) => {
  request.on('response', (res) => {
    if (res.status >= 400) {
      let logMessage = `${res.req.method} ${res.req.url} returned ${
        res.status
      }. Query params ${JSON.stringify(res.req.query)}. Error: ${res.error.message}`;
      logToAppInsights('Request', logMessage, 'error');
    }
  });
};

let notFoundRequest = (request) => {
  request.on('response', (res) => {
    if (res.status === 404 && res.body) {
      window.location = '/not-found';
    }
  });
};

let authorizationDenied = (request) => {
  request.on('response', (res) => {
    if (res.status === 401 && res.body) {
      window.location = '/unauthorized';
    }
  });
};

Helpers.get = (url, headers = {}, query = {}, token = true) => {
  let defaultHeaders = {
    Accept: 'application/json',
  };

  return getAccessTokenAsync(token).then((res) => {
    if (res != null) {
      let accesstoken = res.accessToken;
      defaultHeaders['Authorization'] = `Bearer ${accesstoken}`;
    }

    return request
      .get(url)
      .use(logRequest)
      .use(notFoundRequest)
      .use(authorizationDenied)
      .query(query)
      .set(Object.assign({}, defaultHeaders, headers));
  });
};

Helpers.post = (url, headers = {}, data, query = {}, token = true) => {
  let defaultHeaders = {
    Accept: 'application/json',
  };

  return getAccessTokenAsync(token).then((res) => {
    if (res != null) {
      let accesstoken = res.accessToken;
      defaultHeaders['Authorization'] = `Bearer ${accesstoken}`;
    }

    return request
      .post(url)
      .use(logRequest)
      .use(authorizationDenied)
      .query(query)
      .set(Object.assign({}, defaultHeaders, headers))
      .send(data);
  });
};

Helpers.put = (url, headers = {}, data, token = true) => {
  let defaultHeaders = {
    Accept: 'application/json',
  };

  return getAccessTokenAsync(token).then((res) => {
    if (res != null) {
      let accesstoken = res.accessToken;
      defaultHeaders['Authorization'] = `Bearer ${accesstoken}`;
    }

    return request
      .put(url)
      .use(logRequest)
      .use(authorizationDenied)
      .set(Object.assign({}, defaultHeaders, headers))
      .send(data);
  });
};

Helpers.delete = (url, headers = {}, query = {}, token = true) => {
  let defaultHeaders = {
    Accept: 'application/json',
  };

  return getAccessTokenAsync(token).then((res) => {
    if (res != null) {
      let accesstoken = res.accessToken;
      defaultHeaders['Authorization'] = `Bearer ${accesstoken}`;
    }

    return request
      .delete(url)
      .use(logRequest)
      .use(authorizationDenied)
      .query(query)
      .set(Object.assign({}, defaultHeaders, headers));
  });
};

export default Helpers;
